<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h3 class="headings">VAMP Details</h3>
    </div>
  </div>

  <!-- ===== Summary — single details card; zeros/defaults when empty ===== -->
  <div class="b_shadow mt-3">
    <div class="heading-card">
      <div class="row">
        <div class="col-12 left-heading pl-xl-5 pl-lg-5 pl-sm-5"><span>Summary</span></div>
      </div>
    </div>
    <div class="px-xl-5 px-lg-5 px-sm-4 px-3 py-xl-4 py-lg-4 py-3">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-12" *ngFor="let field of summaryFields">
          <div class="vamp-field">
            <span class="vamp-field-label">{{ field.label }}</span>
            <span class="vamp-field-value" [ngSwitch]="field.type">
              <span *ngSwitchCase="'money'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | currency:'USD':'symbol':'1.2-2') : '$0.00' }}</span>
              <span *ngSwitchCase="'number'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | number) : 0 }}</span>
              <span *ngSwitchCase="'percent'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | number:'1.2-4') + '%' : '0.00%' }}</span>
              <span *ngSwitchDefault>{{ displaySummary[field.key] != null && displaySummary[field.key] !== '' ? displaySummary[field.key] : '--' }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== TC-40 transactions — same shell as Card Transactions (ws:rollout) ===== -->
  <payarc-filter-bar class="vamp-filter-row">
    <payarc-search placeholder="Search" [value]="searchText" (valueChange)="searchText = $event; searchHits.next()"></payarc-search>
    <input [matDatepicker]="df" [(ngModel)]="from" [max]="to" (click)="df.open()"
           class="pa-input" style="width:150px" placeholder="From" aria-label="From date" readonly>
    <mat-datepicker #df (closed)="onDateChange()"></mat-datepicker>
    <input [matDatepicker]="dt" [(ngModel)]="to" [min]="from" [max]="today" (click)="dt.open()"
           class="pa-input" style="width:150px" placeholder="To" aria-label="To date" readonly>
    <mat-datepicker #dt (closed)="onDateChange()"></mat-datepicker>
    <ng-container actions>
      <button type="button" payarcButton="primary" [disabled]="!totalRecords" (click)="export('csv')">Export CSV</button>
      <button type="button" payarcButton="primary" [disabled]="!totalRecords" (click)="export('xls')">Export XLS</button>
    </ng-container>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <payarc-table class="vamp-table">
      <thead>
        <tr>
          <th *ngFor="let col of columns" [style.min-width.px]="col.width" [class.num]="col.type === 'money'"
              [attr.aria-sort]="sortAriaFor(col.key)">
            <button type="button" class="pa-th-sort" (click)="setSorting(col.key)">{{ col.label }}
              <payarc-sort-icon [direction]="sortDirectionFor(col.key)"></payarc-sort-icon></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag2">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
            <td *ngFor="let c of columns"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <ng-container *ngIf="!loadFlag2 && rows.length">
          <tr *ngFor="let tx of rows">
            <td *ngFor="let col of columns" [attr.data-th]="col.label" [class.num]="col.type === 'money'" [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'date'">{{ tx[col.key] ? (tx[col.key] | date:'MM/dd/yyyy') : '--' }}</ng-container>
              <ng-container *ngSwitchCase="'money'">{{ tx[col.key] != null ? (tx[col.key] | currency:'USD':'symbol':'1.2-2') : '--' }}</ng-container>
              <ng-container *ngSwitchDefault>{{ tx[col.key] != null && tx[col.key] !== '' ? tx[col.key] : '--' }}</ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>

    <!-- Outside the (very wide, horizontally scrolling) table so it centres in the visible card. -->
    <payarc-empty-state *ngIf="!loadFlag2 && !rows.length" title="No VAMP transactions" [message]="noDataMessage"></payarc-empty-state>

    <div class="vamp-pager-row" *ngIf="!loadFlag2 && totalRecords">
      <!-- Same rows-per-page control as the other ws:rollout lists (e.g. customer-list). -->
      <label class="vamp-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="setUrl()">
          <option *ngFor="let no of limitArray" [ngValue]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="page"
        [disablePrev]="page <= 1"
        [disableNext]="page >= totalPages"
        (prev)="prevPage()"
        (next)="nextPage()"
        (pageSelect)="goToPage($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>

  <div class="row">
    <div class="col-12 vamp-disclaimer">
      To inquire about a specific transaction or dispute a transaction, contact
      <a [href]="disputeMailto">Risk&#64;payarc.com</a>
    </div>
  </div>
</div>
